type HiddenSlideState = {
  isHidden?: boolean | null,
  sourceIsHidden?: boolean | null,
};

type HiddenSlideTooltipState = HiddenSlideState & {
  deviceMode?: string | null,
};

export const HIDDEN_SLIDE_TOOLTIP = 'This slide was originally hidden when uploaded into the platform.';

export const getHiddenSlideTooltip = ({
  isHidden,
  sourceIsHidden,
}: HiddenSlideState): string | undefined => (
  isHidden && sourceIsHidden ? HIDDEN_SLIDE_TOOLTIP : undefined
);

export const shouldShowHiddenSlideTooltip = ({
  deviceMode,
  ...hiddenSlideState
}: HiddenSlideTooltipState): boolean => (
  deviceMode === 'desktop' && !!getHiddenSlideTooltip(hiddenSlideState)
);
